import { render, staticRenderFns } from "./UpdateSchool.vue?vue&type=template&id=40277165&scoped=true"
import script from "./UpdateSchool.vue?vue&type=script&lang=js"
export * from "./UpdateSchool.vue?vue&type=script&lang=js"
import style0 from "./UpdateSchool.vue?vue&type=style&index=0&id=40277165&lang=css"
import style1 from "./UpdateSchool.vue?vue&type=style&index=1&id=40277165&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40277165",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40277165')) {
      api.createRecord('40277165', component.options)
    } else {
      api.reload('40277165', component.options)
    }
    module.hot.accept("./UpdateSchool.vue?vue&type=template&id=40277165&scoped=true", function () {
      api.rerender('40277165', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/UpdateSchool.vue"
export default component.exports